export default "/_next/static/chunks/fonts/Zocial-07fea2ac49bcc67d9a6bcc25835e1716.ttf";